import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n      background-color: ', ';\n      color: ', ';\n    '], ['\n      background-color: ', ';\n      color: ', ';\n    ']),
    _templateObject2 = _taggedTemplateLiteral(['\n      background-image: ', ';\n    '], ['\n      background-image: ', ';\n    ']),
    _templateObject3 = _taggedTemplateLiteral(['\n      background-color: ', ';\n    '], ['\n      background-color: ', ';\n    ']),
    _templateObject4 = _taggedTemplateLiteral(['\n      background: ', ';\n      border: 1px solid ', ';\n      color: ', ';\n    '], ['\n      background: ', ';\n      border: 1px solid ', ';\n      color: ', ';\n    ']),
    _templateObject5 = _taggedTemplateLiteral(['\n  color: ', ';\n  display: none;\n  font-size: 11px;\n  font-weight: 600;\n  left: 8px;\n  line-height: 1;\n  padding: 7px 13px;\n  position: absolute;\n  text-transform: uppercase;\n  top: 8px;\n  z-index: 1;\n  ', '\n\n  ', '\n'], ['\n  color: ', ';\n  display: none;\n  font-size: 11px;\n  font-weight: 600;\n  left: 8px;\n  line-height: 1;\n  padding: 7px 13px;\n  position: absolute;\n  text-transform: uppercase;\n  top: 8px;\n  z-index: 1;\n  ', '\n\n  ', '\n']);

import styled, { css } from 'styled-components';

var badgeTextStyles = function badgeTextStyles(_ref) {
  var badgeText = _ref.badgeText,
      theme = _ref.theme;

  if (badgeText === 'Pre Order') {
    return css(_templateObject, theme.dormifyGreen, theme.dormifyBlack);
  } else if (badgeText === 'Best Seller') {
    return css(_templateObject2, theme.dormifyPinkButtonNoHover);
  } else if (badgeText === 'New') {
    return css(_templateObject3, theme.dormifyBlack);
  } else if (badgeText === 'Low Stock') {
    return css(_templateObject4, theme.dormifyWhite, theme.dormifyLightGrey, theme.dormifyBlack);
  }
};

export var StyledBadge = styled.div(_templateObject5, function (props) {
  return props.theme.dormifyWhite;
}, function (_ref2) {
  var active = _ref2.active;
  return active && 'display: block;';
}, badgeTextStyles);